@if (cpsReady) {
  <mat-form-field class="full-width">
    <mat-label>{{label}}</mat-label>
    <mat-select [(ngModel)]="formulaKey"
      [compareWith]="compareFormula"
      (selectionChange)="formulaSelected($event)">
      <mat-option [value]="null">None</mat-option>
      @for (option of nameFormulaOptions | keyvalue; track option.key) {
        <mat-option [value]="option.key">{{getNameString(option.value)}}</mat-option>
      }
    </mat-select>
  </mat-form-field>
}
